module.exports = __webpack_public_path__ + "img/background_qr2.4ba431dd.webp";